/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class AccountValuesGrid extends SiteEntityGrid<AccountValueRow, any> {
        protected getColumnsKey() { return 'Data.AccountValue'; }
        protected getDialogType() { return AccountValueDialog; }
        protected getIdProperty() { return AccountValueRow.idProperty; }
        protected getLocalTextPrefix() { return AccountValueRow.localTextPrefix; }
        protected getService() { return AccountValueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != AccountValueRow.Fields.AccountCode);
        }

        protected getGridCanLoad() {
            return !!this._accountCode;
        }

        private _accountCode: string;

        public get accountCode() {
            return this._accountCode;
        }

        public set accountCode(value: string) {
            if (this._accountCode != value) {
                this._accountCode = value;
                this.setEquality(AccountValueRow.Fields.AccountCode, value);
                this.refresh();
            }
        }
    }
}